/* eslint-disable camelcase */

import React from 'react'

// Local import
import TextField from '../BasicFields/TextField'
import SelectField from '../BasicFields/SelectField'
import { updateErrors } from '../SectionField'
import TrashCanIcon from '../../ui/icons/TrashCanIcon'
import DuplicateIcon from '../../ui/icons/DuplicateIcon'
import QuestionSettings from './QuestionSettings'

class Variable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: props.question.id,
      context: props.question.context,
      position: props.question.position,
      title: props.question.title,
      mandatory: props.question.mandatory,
      variable_id: props.question.variable_id,
      errors: props.question.errors || {}
    }
  }

  shouldComponentUpdate(_nextProps, nextState) {
    this.state.errors = updateErrors(this.state.errors, this.props.getErrors)

    return (
      this.state.title !== nextState.title ||
      this.state.mandatory !== nextState.mandatory ||
      this.state.position !== nextState.position ||
      this.state.variable_id !== nextState.variable_id ||
      this.state.errors.isNew === true
    )
  }

  componentDidUpdate() {
    this.props.handleQuestionChange(this.state)
  }

  handleChange = event => this.setState({ [event.target.name]: event.target.value })

  handleMandatoryChange = event => this.setState({ mandatory: event.target.checked })

  render() {
    return (
      <div className="nested-fields ml-2 ml-md-4">
        <div className="d-flex">
          <div className="mr-auto">
            <i className="fas fa-arrows-alt c-pointer" {...this.props.dragHandleProps} />
            {' Question avec variable '}
            <DuplicateIcon
              className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
              onClick={this.props.handleQuestionDuplicate(this.state.id)}
            />
          </div>
          <TrashCanIcon
            className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
            onClick={this.props.handleQuestionRemove(this.state.id)}
          />
        </div>
        <TextField
          name="title"
          value={this.state.title}
          placeholder="Titre de la question..."
          errors={this.state.errors.title}
          onChange={this.handleChange}
        />
        <SelectField
          name="variable_id"
          label="Variable"
          data={this.props.data.variables}
          value={this.state.variable_id}
          errors={this.state.errors.variable}
          includeBlank
          onChange={this.handleChange}
        />
        <QuestionSettings
          id={this.state.id}
          mandatory={this.state.mandatory}
          onMandatoryChange={this.handleMandatoryChange}
        />
      </div>
    )
  }
}

export default Variable
